document.addEventListener('DOMContentLoaded', function() {
    const closeButtons = document.querySelectorAll('.close-safety-section-btn');

    closeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const safetySection = this.closest('.safety-recall-section');
            if (safetySection) {
                safetySection.classList.add('d-none');
            }
        });
    });
});